function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12.57 8.81"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.28.29a1 1 0 0 0-1.42 0L4.75 6.4l-3-3.05A1 1 0 0 0 .29 4.77l3.76 3.75a1 1 0 0 0 1.41 0l6.82-6.81a1 1 0 0 0 0-1.42",
  "data-name": "Layer 1",
  style: {
    fill: "#fff"
  }
})));
export default SvgChecked;